import { Grid, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValuesB2B } from '../FormPageB2B';

interface RowOfStatementProps {
    formik: FormikProps<FormValuesB2B>;
    title: string;
    name: keyof FormValuesB2B;
    input?: React.ReactNode;
    additionalInput?: React.ReactNode;
    show?: boolean;
}

const AccountB2B = ({ title, input, show = true }: RowOfStatementProps) => {

    if (!show) return <></>;
    return (
        <Grid container spacing={6} alignItems="flex-start" direction={{ xs: 'column', sm: 'row' }} sx={{marginTop: '60px' }}>
            <Grid size={{ xs: 12, sm: 12, md: 5 }} sx={{ height: 'auto' }}>
                <Typography variant="h6" sx={{ margin: 0, padding: '0px' }}>{title}</Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 7 }} >
                {input}

            </Grid>

        </Grid>
    );
};

export default AccountB2B;
